const categories = [
	{ name: 'love', color: '#c23616' },

	{ name: 'strength', color: '#40739e' },
	{ name: 'success', color: '#6B54DE' },
	{ name: 'money', color: '#308523' },
	{ name: 'wisdom', color: '#273c75' },
];
export default categories;
